var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorSupplymintLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 64,
    viewBox: "0 0 57 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.2063,
    y: 0.824219,
    width: 38,
    height: 38,
    rx: 6.33333,
    fill: "#5D5FEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0756,
    y: 10.8516,
    width: 1.69643,
    height: 9.04762,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.02,
    y: 9.50391,
    width: 1.69643,
    height: 15.0046,
    transform: "rotate(51.8154 27.02 9.50391)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3674,
    y: 20.2031,
    width: 1.69643,
    height: 12.6055,
    transform: "rotate(33.096 27.3674 20.2031)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5537,
    y: 20.168,
    width: 1.69643,
    height: 12.6055,
    transform: "rotate(-24.7049 15.5537 20.168)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3398,
    y: 19.4102,
    width: 1.69643,
    height: 11.8788,
    transform: "rotate(27.4657 39.3398 19.4102)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1406,
    y: 20.9219,
    width: 1.69643,
    height: 21.9476,
    transform: "rotate(-62.2575 15.1406 20.9219)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3597,
    y: 19.8438,
    width: 1.69643,
    height: 22.1259,
    transform: "rotate(62.9104 40.3597 19.8438)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2062,
    cy: 9.72284,
    r: 2.2619,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2062,
    cy: 19.9025,
    r: 2.2619,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8972,
    cy: 19.9025,
    r: 2.2619,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4204,
    cy: 30.0783,
    r: 2.2619,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5163,
    cy: 19.9025,
    r: 2.2619,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.9923,
    cy: 30.0783,
    r: 2.2619,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8904_10782)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.06873,
    y: 42.8242,
    width: 46,
    height: 14,
    rx: 7,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7877 46.4612L12.3447 51.2492L13.9017 46.4612H15.5487L13.3347 52.8242H11.3457L9.14073 46.4612H10.7877ZM17.6778 47.6852V49.0172H19.8288V50.1782H17.6778V51.5912H20.0988V52.8242H16.1388V46.4612H20.0988V47.6852H17.6778ZM26.6248 52.8242H25.0858L22.5118 48.9182V52.8242H20.9728V46.4612H22.5118L25.0858 50.4032V46.4612H26.6248V52.8242ZM33.4116 49.6292C33.4116 50.2532 33.2766 50.8082 33.0066 51.2942C32.7426 51.7742 32.3586 52.1492 31.8546 52.4192C31.3566 52.6892 30.7686 52.8242 30.0906 52.8242H27.6876V46.4612H30.0906C30.7746 46.4612 31.3656 46.5932 31.8636 46.8572C32.3616 47.1212 32.7426 47.4932 33.0066 47.9732C33.2766 48.4532 33.4116 49.0052 33.4116 49.6292ZM29.9556 51.4472C30.5556 51.4472 31.0206 51.2882 31.3506 50.9702C31.6866 50.6522 31.8546 50.2052 31.8546 49.6292C31.8546 49.0532 31.6866 48.6062 31.3506 48.2882C31.0206 47.9702 30.5556 47.8112 29.9556 47.8112H29.2266V51.4472H29.9556ZM37.3122 46.3622C37.9122 46.3622 38.4552 46.5032 38.9412 46.7852C39.4332 47.0612 39.8202 47.4482 40.1022 47.9462C40.3842 48.4382 40.5252 48.9962 40.5252 49.6202C40.5252 50.2442 40.3812 50.8052 40.0932 51.3032C39.8112 51.8012 39.4242 52.1912 38.9322 52.4732C38.4462 52.7492 37.9062 52.8872 37.3122 52.8872C36.7182 52.8872 36.1752 52.7492 35.6832 52.4732C35.1972 52.1912 34.8102 51.8012 34.5222 51.3032C34.2402 50.8052 34.0992 50.2442 34.0992 49.6202C34.0992 48.9962 34.2402 48.4382 34.5222 47.9462C34.8102 47.4482 35.1972 47.0612 35.6832 46.7852C36.1752 46.5032 36.7182 46.3622 37.3122 46.3622ZM37.3122 47.7932C36.8082 47.7932 36.4062 47.9582 36.1062 48.2882C35.8122 48.6122 35.6652 49.0562 35.6652 49.6202C35.6652 50.1782 35.8122 50.6222 36.1062 50.9522C36.4062 51.2822 36.8082 51.4472 37.3122 51.4472C37.8102 51.4472 38.2092 51.2822 38.5092 50.9522C38.8092 50.6222 38.9592 50.1782 38.9592 49.6202C38.9592 49.0622 38.8092 48.6182 38.5092 48.2882C38.2152 47.9582 37.8162 47.7932 37.3122 47.7932ZM44.6568 52.8242L43.2798 50.4212H42.9288V52.8242H41.3898V46.4612H44.0178C44.5218 46.4612 44.9478 46.5482 45.2958 46.7222C45.6438 46.8962 45.9048 47.1362 46.0788 47.4422C46.2528 47.7422 46.3398 48.0872 46.3398 48.4772C46.3398 48.9392 46.2108 49.3322 45.9528 49.6562C45.7008 49.9802 45.3318 50.2022 44.8458 50.3222L46.3578 52.8242H44.6568ZM42.9288 49.3682H43.8828C44.1888 49.3682 44.4138 49.3022 44.5578 49.1702C44.7018 49.0322 44.7738 48.8312 44.7738 48.5672C44.7738 48.3152 44.6988 48.1172 44.5488 47.9732C44.4048 47.8292 44.1828 47.7572 43.8828 47.7572H42.9288V49.3682Z",
    fill: "#23235F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8904_10782",
    x: 0.0687256,
    y: 39.8242,
    width: 56,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.863365 0 0 0 0 0.859271 0 0 0 0 0.9125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8904_10782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8904_10782",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorSupplymintLogo);
export default __webpack_public_path__ + "static/media/VendorSupplymintLogo.a46fa4d15d99b2944f07c7709ef40cfa.svg";
export { ForwardRef as ReactComponent };